@let pushNotifications = pushNotifications$ | async; @let device = device$ | async; @let organization = organization$ |
async; @let setting = setting$ | async; @let monetization = monetization$ | async; @let office = office$ | async; @let
titleRep = titleRep$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Debug</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Actions</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label>Synchronization</ion-label>
    </ion-item-divider>
    <ion-item (click)="syncConfiguration()" [detail]="true">
      <ion-icon color="warning" name="sync" slot="start"></ion-icon>
      <ion-label color="warning">Sync Configuration</ion-label>
    </ion-item>
    <ion-item (click)="syncUser()" [detail]="true">
      <ion-icon color="warning" name="sync" slot="start"></ion-icon>
      <ion-label color="warning">Sync User</ion-label>
    </ion-item>
    <ion-item-divider>
      <ion-label>Key Reset</ion-label>
    </ion-item-divider>
    <ion-item (click)="resetProfileKey()" [detail]="true">
      <ion-icon color="warning" name="refresh-circle-outline" slot="start"></ion-icon>
      <ion-label color="warning">Reset Property Profile Key</ion-label>
    </ion-item>
    <ion-item (click)="resetWalkingFarmKey()" [detail]="true">
      <ion-icon color="warning" name="refresh-circle-outline" slot="start"></ion-icon>
      <ion-label color="warning">Reset Walking Farm Key</ion-label>
    </ion-item>
    <ion-item-divider>
      <ion-label>Notifications</ion-label>
    </ion-item-divider>
    <ion-item
      (click)="sendTestPushNotification('farmAlerts')"
      [detail]="true"
      [disabled]="!pushNotifications?.token?.value"
    >
      <ion-icon color="warning" name="notifications-outline" slot="start"></ion-icon>
      <ion-label color="warning">Send Farm Alerts Notification</ion-label>
    </ion-item>
    <ion-item (click)="sendTestPushNotification()" [detail]="true" [disabled]="!pushNotifications?.token?.value">
      <ion-icon color="warning" name="notifications-outline" slot="start"></ion-icon>
      <ion-label color="warning">Send Generic Notification</ion-label>
    </ion-item>
  </ion-list>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Device Information</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label>{{device?.model | redDashIfEmpty}}</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Device Type</ion-label>
      <ion-note slot="end">{{device?.deviceType | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Screen Dimensions</ion-label>
      <ion-note slot="end">{{device?.deviceDimensions | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">OS</ion-label>
      <ion-note slot="end">{{device?.os | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">OS Version</ion-label>
      <ion-note slot="end">{{device?.osVersion | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Device ID<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{device?.uuid | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Device Data<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{device?.deviceData | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Application</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label>{{organization?.applicationName | redDashIfEmpty}}</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Version</ion-label>
      <ion-note slot="end">{{device?.appVersion | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Referral Code</ion-label>
      <ion-note slot="end">{{setting?.referralCode | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item-divider>
      <ion-label>Tokens</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">
        Property Profile Key<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{(profileKey$ | async) | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Walking Farm Key<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{(walkingFarmKey$ | async) | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    <ion-item-divider>
      <ion-label>Push Notifications</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Initialized</ion-label>
      <ion-badge slot="end" [redBooleanToYes]="pushNotifications?.registrationInitiated"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Initialization Error<br />
        <ion-note class="tw:text-sm tw:text-wrap">
          {{ pushNotifications?.registrationError?.toString() | redDashIfEmpty}} </ion-note
        ><br />
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Token<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{pushNotifications?.token?.value | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    <ion-item-divider>
      <ion-label>Preferences</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Use Alternate Icon</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="setting?.alternateAppIconUsed"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Map Layer</ion-label>
      <ion-note slot="end">{{(map$ | async)?.currentMapType | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">State</ion-label>
      <ion-note slot="end">{{setting?.selectedState | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">County</ion-label>
      <ion-note slot="end">{{setting?.selectedCounty | redDashIfEmpty}}</ion-note>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Monetization</ion-label>
    </ion-list-header>
    <ion-item>
      <ion-label color="medium">Enabled</ion-label>
      <ion-badge slot="end" [redBooleanToYes]="monetization?.isEnabled"></ion-badge>
    </ion-item>
    <ion-item-divider color="primary">
      <ion-label>Primary Plan</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Enabled</ion-label>
      <ion-badge slot="end" [redBooleanToYes]="monetization?.primarySubscriptionIsEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Active</ion-label>
      <ion-badge slot="end" [redBooleanToYes]="monetization?.primarySubscriptionIsActive"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Name</ion-label>
      <ion-note slot="end">{{monetization?.primarySubscriptionPlan | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Behavior</ion-label>
      <ion-note slot="end">{{monetization?.primarySubscriptionAccessAlias | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Entitlement</ion-label>
      <ion-note slot="end">{{monetization?.primarySubscriptionEntitlement | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Offering</ion-label>
      <ion-note slot="end"> {{monetization?.primarySubscriptionOfferingsIdentifier | redDashIfEmpty}} </ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Identifier<br />
        <ion-note class="tw:text-sm tw:text-wrap">
          {{monetization?.primarySubscriptionPlatformProductIdentifier | redDashIfEmpty}}
        </ion-note>
      </ion-label>
    </ion-item>
    <ion-item-divider>
      <ion-label>Farm</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Phones and Emails</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="monetization?.phoneAndEmailPurchaseEnabled"></ion-badge>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Organization</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label>{{organization?.name | redDashIfEmpty}}</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Farm Alerts</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="organization?.farmAlertsEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Farm Alerts Auto Subscribe</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="organization?.farmAlertsAutoSubscribe"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Sale Information</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="organization?.saleInformationEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Transaction History</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="organization?.transactionHistoryEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Turnover Rate</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="organization?.turnoverRateEnabled"></ion-badge>
    </ion-item>
    <ion-item-divider>
      <ion-label>Parse</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Parse Type</ion-label>
      <ion-note slot="end">{{setting?.parseType | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Parse App Key</ion-label>
      <ion-note slot="end">{{setting?.applicationKey | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item-divider>
      <ion-label>White Labeling</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">
        Alternate Icon Name<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{organization?.alternateAppIconName | redDashIfEmpty}} </ion-note>
      </ion-label>
    </ion-item>
    @if (organization?.alternateAppIconPreviewUrl) {
    <ion-item>
      <ion-avatar class="tw:relative tw:h-10" aria-hidden="true" slot="end">
        <img alt="Alternate Icon" class="tw:object-contain" ngSrc="{{organization?.alternateAppIconPreviewUrl}}" fill />
      </ion-avatar>
      <ion-label color="medium">Alternate Icon Preview</ion-label>
    </ion-item>
    }
  </ion-list>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Office</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label>{{office?.name | redDashIfEmpty}}</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Calculators</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.calculatorsEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Net Sheet</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.netSheetsEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Walking Farm</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.walkingFarmEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Document Links</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.documentLinksEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Contact Card</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.contactCardEnabled"></ion-badge>
    </ion-item>
    <ion-item>
      <ion-label color="medium">
        Order Title<br />
        <ion-note class="tw:text-sm tw:text-wrap"> {{office?.orderTitleEmail | redDashIfEmpty}} </ion-note>
      </ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.orderTitleEnabled"></ion-badge>
    </ion-item>
    <ion-item-divider>
      <ion-label>Data Provider</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Provider</ion-label>
      <ion-note slot="end">{{(providerId$ | async) | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label color="medium">Provider Username</ion-label>
      <ion-note slot="end">{{(providerUsername$ | async) | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item-divider>
      <ion-label>Monetization</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Purchase Phones and Emails</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="office?.purchasePhoneAndEmailEnabled"></ion-badge>
    </ion-item>
  </ion-list>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-list-header>
      <ion-label>Title Rep</ion-label>
    </ion-list-header>
    <ion-item-divider color="primary">
      <ion-label> {{[titleRep?.firstName, titleRep?.lastName].join(' ') | redDashIfEmpty}} </ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label color="medium">Order Title CC</ion-label>
      <ion-badge slot="end" [redBooleanToEnabled]="titleRep?.orderTitleCCEnabled"></ion-badge>
    </ion-item>
  </ion-list>
</red-page-content>
